<template>
  <b-container fluid>
    <b-row>
      <b-container>
        <SearchForm/>
        <b-card class="bg-light p-2" no-body="">
          <b-row class="align-items-center">
            <b-col md="7">
              <b>RESULTS:</b>
            </b-col>
            <b-col md="5">
              <SortFields/>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
import SearchForm from './components/search_form'
import SortFields from '@/app/private/shared/components/sort_fields'
// import SearchResultsSummary from './components/search_results_summary'
export default {
  components: { SearchForm, SortFields }
}
</script>

<style lang="scss">

</style>
